export default __webpack_public_path__ + "static/media/index-01.42113edb.png";